module.exports = __webpack_public_path__ + "img/pr-6.ed3adfb6.png";